var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCookie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 52 52"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "nwaeukydbb",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "yrv86kbz1d",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    values: "0 0 0 0 0.26488904 0 0 0 0 0.187946042 0 0 0 0 0.187946042 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pwzoiwmo1f",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "uw80vvoyag",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    values: "0 0 0 0 0.26488904 0 0 0 0 0.187946042 0 0 0 0 0.187946042 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "cbuz0bgivi",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "eqt2fqjuej",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    values: "0 0 0 0 0.26488904 0 0 0 0 0.187946042 0 0 0 0 0.187946042 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "rjan7so4rl",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "80racyy8zm",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    values: "0 0 0 0 0.26488904 0 0 0 0 0.187946042 0 0 0 0 0.187946042 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "tuhq1og1wo",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "w6rlzxwx3p",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    values: "0 0 0 0 0.26488904 0 0 0 0 0.187946042 0 0 0 0 0.187946042 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "y88i3pue9r",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "9w38thauqs",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    values: "0 0 0 0 0.26488904 0 0 0 0 0.187946042 0 0 0 0 0.187946042 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ipu17gpy7u",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "2z9fgy8eqv",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    values: "0 0 0 0 0.26488904 0 0 0 0 0.187946042 0 0 0 0 0.187946042 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "2iqf1aklix",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "xx9f4zt88y",
    width: "100%",
    height: "100%",
    x: "0%",
    y: "0%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowOffsetOuter1",
    values: "0 0 0 0 0.26488904 0 0 0 0 0.187946042 0 0 0 0 0.187946042 0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "yhof12hqge",
    cx: 8.62,
    cy: 14.296,
    r: 3.342
  }), /*#__PURE__*/React.createElement("circle", {
    id: "jkxflgma8h",
    cx: 6.548,
    cy: 25.653,
    r: 1.745
  }), /*#__PURE__*/React.createElement("circle", {
    id: "napvweytak",
    cx: 16.765,
    cy: 29.649,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    id: "sh1qdoj1dn",
    cx: 17.984,
    cy: 15.868,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    id: "9tvmyscz2q",
    cx: 33.982,
    cy: 21.787,
    r: 1.22
  }), /*#__PURE__*/React.createElement("circle", {
    id: "z7iz8q825t",
    cx: 22.932,
    cy: 36.406,
    r: 2.082
  }), /*#__PURE__*/React.createElement("circle", {
    id: "1uxdjvdm3w",
    cx: 11.381,
    cy: 1.185,
    r: 2.082
  }), /*#__PURE__*/React.createElement("circle", {
    id: "53hayas5tz",
    cx: 25.646,
    cy: 23.947,
    r: 2.167
  }), /*#__PURE__*/React.createElement("path", {
    id: "h61fobod9a",
    d: "M33.965 26.797a10.587 10.587 0 01-8.826 8.827c-5.232.82-10.465.82-15.698 0a10.589 10.589 0 01-8.826-8.827 50.388 50.388 0 010-15.697c.712-4.548 3.513-8.774 8.062-9.486 3.407-.533 7.579-.06 10.986.101a4.105 4.105 0 00-.86 3.106 4.108 4.108 0 001.195 2.395 4.125 4.125 0 002.362 1.148 4.113 4.113 0 00.181 5.262 4.107 4.107 0 003.075 1.377c.741 0 1.485-.199 2.144-.602.023.976.392 1.89 1.005 2.599a4.107 4.107 0 003.117 1.421 4.11 4.11 0 002.675-.993 50.425 50.425 0 01-.592 9.369z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-20 42.35 .65)",
    fill: "#c6865c",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5prikg1w9c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h61fobod9a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#2B2B2B",
    strokeWidth: 2.082,
    d: "M8.516.586C11.26.156 14.488.353 17.44.542c.783.05 1.545.1 2.273.134h0l2.031.096-1.266 1.591a3.064 3.064 0 00-.67 1.91c.121 1.117.447 1.736.919 2.2.472.462 1.09.772 1.764.858h0l1.809.23-1.118 1.441a3.074 3.074 0 00.136 3.931 3.068 3.068 0 002.298 1.03c.553 0 1.108-.149 1.6-.45h0l1.543-.944.042 1.808a3.075 3.075 0 002.598 2.965c1.232.038 1.936-.238 2.48-.705h0l1.652-1.416.066 2.175a51.553 51.553 0 01-.603 9.562 11.617 11.617 0 01-3.267 6.427 11.622 11.622 0 01-6.427 3.268c-5.34.836-10.68.836-16.02 0a11.637 11.637 0 01-9.694-9.695 51.471 51.471 0 010-16.019c.407-2.593 1.45-5.083 3.057-6.974C4.136 2.208 6.111.962 8.516.586z"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    filter: "url(#nwaeukydbb)",
    mask: "url(#5prikg1w9c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#yrv86kbz1d)",
    xlinkHref: "#yhof12hqge"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5E4545",
    xlinkHref: "#yhof12hqge"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    filter: "url(#pwzoiwmo1f)",
    mask: "url(#5prikg1w9c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#uw80vvoyag)",
    xlinkHref: "#jkxflgma8h"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5E4545",
    xlinkHref: "#jkxflgma8h"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    filter: "url(#cbuz0bgivi)",
    mask: "url(#5prikg1w9c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#eqt2fqjuej)",
    xlinkHref: "#napvweytak"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5E4545",
    xlinkHref: "#napvweytak"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    filter: "url(#rjan7so4rl)",
    mask: "url(#5prikg1w9c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#80racyy8zm)",
    xlinkHref: "#sh1qdoj1dn"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5E4545",
    xlinkHref: "#sh1qdoj1dn"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    filter: "url(#tuhq1og1wo)",
    mask: "url(#5prikg1w9c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#w6rlzxwx3p)",
    xlinkHref: "#9tvmyscz2q"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5E4545",
    xlinkHref: "#9tvmyscz2q"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    filter: "url(#y88i3pue9r)",
    mask: "url(#5prikg1w9c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#9w38thauqs)",
    xlinkHref: "#z7iz8q825t"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5E4545",
    xlinkHref: "#z7iz8q825t"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    filter: "url(#ipu17gpy7u)",
    mask: "url(#5prikg1w9c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#2z9fgy8eqv)",
    xlinkHref: "#1uxdjvdm3w"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5E4545",
    xlinkHref: "#1uxdjvdm3w"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    filter: "url(#2iqf1aklix)",
    mask: "url(#5prikg1w9c)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#xx9f4zt88y)",
    xlinkHref: "#53hayas5tz"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#5E4545",
    xlinkHref: "#53hayas5tz"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M30.027 7.706l-.137-.137a1.297 1.297 0 01-.06-1.772l1.38-1.584a1.3 1.3 0 011.898-.065l.34.34a1.3 1.3 0 01-.065 1.899l-1.584 1.38a1.3 1.3 0 01-1.772-.06zM25.453 5.42l-.187-.05a1.299 1.299 0 01-.939-1.504l.405-2.062c.144-.74.883-1.2 1.61-1.006l.465.125a1.3 1.3 0 01.893 1.676l-.682 1.988a1.298 1.298 0 01-1.565.833zm6.773 6.91l-.05-.187a1.298 1.298 0 01.833-1.565l1.988-.682a1.299 1.299 0 011.676.893l.125.465a1.299 1.299 0 01-1.006 1.611l-2.061.404a1.301 1.301 0 01-1.505-.939z",
    fill: "#7887FF",
    fillRule: "nonzero"
  }))));
}

export default "data:image/svg+xml;base64,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";
export { SvgIconCookie as ReactComponent };